module.exports = {
  armsInterface: 'http://arms.tencentyun.com:50022',
  cacheInterface: 'http://sg.intl.cache.tencentyun.com:50022',
  newCacheInterface: 'http://hk.intl.cache.woa.com:50022',
  capiInterface: 'api.tencentyun.com',
  capiInterfaceV3: 'ap-hongkong.api.tencentyun.com',
  verifyCaptchaInterface: 'http://mcproxy.isd.com/VerifyCode.php',
  cloudBillInterface: 'http://cloudBill.tencentyun.com/interfaces/interface.php',
  connectInterface: 'http://hk.intl.connect.woa.com:50010',
  cmsiTofInterface: 'http://tof.cmsi.tencentyun.com:50015',
  imsgInterface: 'http://imsg.is.tencent-cloud.net/interface/request/json',
  accountInterface: 'http://hk.intl.account.tencentyun.com:50001',
  logicInterface: 'http://hk.intl.logical.server.console.woa.com:50016/interface.php',
  backendRebateYunapi: 'http://api.qcintl.tencentyun.com/backend-partner/yunapi/trpc',
  logicForPartnerInterface: 'http://api.qcintl.tencentyun.com/PartnerAccount',
  mcproxyInterface: 'http://hk.intl.mcproxy.woa.com:51000/interface.php',
  messageInterface: 'http://sg.intl.message.tencentyun.com:50011',
  mfaInterface: 'http://hk.intl.mfa.woa.com:50002',
  opcInterface: 'http://opc.tencentyun.com',
  openInterface: 'http://hk.intl.open.woa.com:50101',
  panshiInterface: 'http://panshi.logic.tencentyun.com:8080/interface.php',
  reportlogInterface: 'http://reportlog.tencentyun.com:50005',
  seoInterface: 'http://seo.tencentyun.com',
  stsInterface: 'http://sg.intl.sts.tencentyun.com:50020',
  tradeInterface: 'http://trade.tencentyun.com/interfaces/interface.php',
  waccountInterface: 'http://hk.intl.waccount.woa.com:50003',
  whitelistInterface: 'http://sg.intl.whitelist.tencentyun.com:50032',
  mcGatewayInterface: 'http://cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_gz: 'http://gz.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_sh: 'http://sh.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_shjr: 'http://shjr.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_bj: 'http://bj.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_hk: 'http://hk.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_ca: 'http://ca.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_sg: 'http://sg.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_szjr: 'http://szjr.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_gzopen: 'http://gzopen.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_usw: 'http://usw.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_cd: 'http://cd.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_de: 'http://de.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_kr: 'http://kr.cgateway.tencentyun.com/interfaces/interface.php',
  mcGatewayInterface_cq: 'http://cq.cgateway.tencentyun.com/interfaces/interface.php',
};